<template>
  <HMTable :items="items" :fields="tableFields" class="mt-4 w-100">
    <template #name="{ data }">
      {{ data.quiz.quiz_name }}
    </template>
    <template #status="{ data }">
      <HMTag :status="formatStatus(data)">
        {{ getStatus(data) }}
      </HMTag>
    </template>
    <template #created="{ data }">
      {{ formatDate(data.created) }}
    </template>
    <template #action="{ data }">
      <a class="link c-brand-color pointer" @click="viewSolvedQuiz(data)">
        {{ $t('QUIZZES.BUTTON.VIEW_QUIZ') }}
      </a>
    </template>
  </HMTable>
</template>

<script lang="ts">
import { formatDate } from '@/utils/format';
import StudentQuizSubmissionViewer from '@/components/quizzes/StudentQuizSubmissionViewer.vue';

export default {
  name: 'StudentSolvedQuizzesTable',
  props: {
    items: {
      type: Array,
    },
  },
  data() {
    return {
      tableFields: [
        {
          name: 'name',
          title: this.$t('QUIZZES.TABLE.QUIZ'),
          cssClass: 'h5',
        },
        {
          name: 'status',
          title: this.$t('QUIZZES.TABLE.STATUS'),
          cssClass: 'd-flex align-items-center',
        },
        {
          name: 'created',
          title: this.$t('QUIZZES.TABLE.DATE_TAKEN'),
        },
        {
          name: 'action',
          shrink: true,
          cssClass: 'p-0 text-center',
        },
      ],
    };
  },
  methods: {
    viewSolvedQuiz(solvedQuiz) {
      console.log('viewing', solvedQuiz);
      this.$modal.show(
        StudentQuizSubmissionViewer,
        {
          solvedQuiz,
        },
        {
          contentClass: ['vm--inline-modal'],
        }
      );
    },
    formatDate(date: string): string {
      if (!date) return '';
      return formatDate(date, 'date-time');
    },
    getStatus(solvedQuizData) {
      if (solvedQuizData?.quiz_snapshot?.is_gradable) {
        if (solvedQuizData.is_graded) {
          if (solvedQuizData.is_passed) {
            return this.$t('QUIZZES.STATUS.PASSED');
          } else {
            return this.$t('QUIZZES.STATUS.FAILED_WITH_SCORE', {
              score: solvedQuizData.grade_achieved_score,
            });
          }
        } else {
          // not yet graded
          return this.$t('QUIZZES.STATUS.IN_REVIEW');
        }
      } else {
        return this.$t('QUIZZES.STATUS.SUBMITTED');
      }
    },
    formatStatus(solvedQuizData) {
      if (solvedQuizData?.quiz_snapshot?.is_gradable) {
        if (solvedQuizData.is_graded) {
          if (solvedQuizData.is_passed) {
            return 'passed';
          } else {
            return 'failed';
          }
        } else {
          return 'review';
        }
      } else {
        return 'submitted';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/components-variables.scss';

.dot {
  margin-right: 0.5rem;
  font-size: 0.5rem;

  &.dot--passed,
  &.dot--submitted {
    color: $light-green;
  }

  &.dot--failed {
    color: $coral;
  }

  &.dot--review {
    color: $mustard;
  }
}

.close-icon {
  width: 20px;
  color: $medium-gray;
  vertical-align: middle;
  cursor: pointer;
  padding: 0 0.25rem;
  &:hover {
    color: var(--brand-color, $coral);
  }
}
</style>
